<template>
    <div v-if="isAdmin">
        <h2>Users List - select a user</h2>


        <v-row align="center">
            <v-col cols="10">
                <v-autocomplete
                        @change="userSelected"
                        v-model="currentUserSelected"
                        :items="usersList"
                        item-text="name"
                        item-value="id"
                        dense
                        filled
                        auto-select-first
                        label="Filled"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "AdminUserDropDown",
        methods: {
            userSelected() {
                this.setCurrentUser(this.currentUserSelected)
                this.setPrecartProduct()
            }
        },
        props:['isAdmin','usersList','currentUserSelected','setPrecartProduct','setCurrentUser']
    }
</script>

<style scoped>

</style>